export const disableGoogleOneTapAutoLogin = (): void => {
    // Notifies Google NOT to auto re-login if user intentionally logged out.
    window?.google?.accounts?.id?.disableAutoSelect();
};
